import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogModule, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-cvat-labels',
  standalone: true,
  imports: [MatDialogModule, CommonModule, MatButtonModule, MatDialogTitle],
  templateUrl: './dialog-cvat-labels.component.html',
  styleUrl: './dialog-cvat-labels.component.scss'
})
export class DialogCvatLabelsComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogCvatLabelsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title: string; duplicate: string[]; added: string[] }){}
}
